import { EUserRoles } from '@entities/user/lib/const';
import type { TUser } from '@entities/user/lib/types';

export const INIT_USER_DATA: TUser = {
  id: '',
  avatar: {
    thumb: '',
    normal: '',
  },
  createdAt: 0,
  email: '',
  employeeVersion: '',
  isBlocked: false,
  isConfirmedEmail: false,
  name: '',
  resetToken: '',
  role: EUserRoles.user,
  shouldSetPassword: false,
  otpEnabled: false,
  otpVerify: false,
  surname: '',
  updatedAt: 0,
  lastActivity: 0,
};
